import { data } from '../../svg/ArrowDown/data';
import { makeIcon } from '../makeIcon';

export const ArrowDown = makeIcon(data, 'arrow_downward', 'ArrowDown');

export default ArrowDown;
